import axios from "axios";
import Config from "../utils/Config";

class GroupService {
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

    // get country codes
    async getCountryCodes (accessToken, groupId, companyId){
    this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + "/api/data/country-codes", //api/data/country-codes
            this.config
        )
        return data.data;
    }

    //get group by id
    async getGroupById (accessToken, groupId, companyId, id){
      this.setAccessToken(accessToken, groupId, companyId);
          const data = await axios.get(
              Config.BACKEND_URL + `/api/group/${id}`, //api/group/:id
              this.config
          )
          return data.data;
      }

      //get groups
    async getAllGroups (accessToken, groupId, companyId){
      this.setAccessToken(accessToken, groupId, companyId);
          const data = await axios.get(
              Config.BACKEND_URL + "/api/group", //api/group
              this.config
          )
          return data.data;
      }

      //create group
      async createGroup (accessToken, groupId, companyId, formData){
        this.setAccessToken(accessToken, groupId, companyId);
    
        const data = await axios.post(
            Config.BACKEND_URL + "/api/group", //api/group
            formData,
            this.config
          )
          return data.data;
      }

      //update group
      async updateGroup (accessToken, groupId, companyId, id, formData){
        this.setAccessToken(accessToken, groupId, companyId);
        
        const data = await axios.put(
            Config.BACKEND_URL + `/api/group/${id}`, //api/group/:id
            formData,
            this.config
          )
          return data.data;
      }

      // get state codes
      async getStateCodes (accessToken, groupId, companyId){
      this.setAccessToken(accessToken, groupId, companyId);
          const data = await axios.get(
              Config.BACKEND_URL + "/api/data/state-codes", //api/data/state-codes
              this.config
          )
          return data.data;
      }

      //get groups for logged user
    async getGroupsForLoggedUser (accessToken, groupId, companyId){
      this.setAccessToken(accessToken, groupId, companyId);
      const sanitizedGroupId = groupId || '';
      const sanitizedCompanyId = companyId || '';
          const data = await axios.get(
              Config.BACKEND_URL + `/api/group/getGroupsForLoggedUser?groupId=${sanitizedGroupId}&companyId=${sanitizedCompanyId}`, //api/user/getMembersForLoggedUser?
              this.config
          )
          //console.log(JSON.stringify(data.data));
          return data.data;
      }
}

export default new GroupService();
